import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Input, Row, Col } from "antd";
import PaymentForm from "../PaymentForm";
class PaymentWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      tip: 0,
    };
  }

  componentWillMount() {
    const that = this;
    let sqPaymentScript = document.createElement("script");
    sqPaymentScript.src = "https://js.squareup.com/v2/paymentform";
    sqPaymentScript.type = "text/javascript";
    sqPaymentScript.async = false;
    sqPaymentScript.onload = () => {
      that.setState({
        loaded: true,
      });
    };
    document.getElementsByTagName("head")[0].appendChild(sqPaymentScript);
  }

  render() {
    return (
      <React.Fragment>
        <div className="order-page">
          <div style={{ marginBottom: "60px" }} className="menu-static-upper">
            <Link to="/home">
              <span style={{ left: "0" }} className="home-ico">
                <i className="fa fa-home"></i>
              </span>
            </Link>
          </div>
          <div className="gray-bold">Payment</div>
          <div style={{ lineHeight: "1" }} className="orange-bold">
            Window
          </div>

          <div style={{ padding: "15px 0px" }} className="orange-light">
            <span>Your order Total is </span>
            <span>
              <b>$ {localStorage.getItem("TotalFinalPrice")}</b>
            </span>
          </div>
          {/* <label>Would you like to add a Tip</label><br />
                   <input type="number" placeholder="" 
                   value={this.state.tip} 
                   className="form-control"
                   onChange={(e)=>{
                   this.setState({tip :e.target.value})}}>

                   </input> */}
          <div style={{ padding: "10px 10px" }}>
            <span style={{ fontSize: "14px " }} className="gray">
              Enter your card details below to confirm order{" "}
            </span>
          </div>
          <div className="pay-box">
            {this.state.loaded && (
              <PaymentForm
                tip={this.state.tip}
                paymentForm={window.SqPaymentForm}
              />
            )}
            {/* <Row>
                   <Col span={24}>                   
                   <Input placeholder="Card Holder Name" />
                   </Col>
                   <Col span={24}>
                   <Input placeholder="Card Number" />
                   </Col>
                   <Row  gutter={16}>
                   <Col span={12}>
                   <Input placeholder="Expiry" />
                   </Col>
                   <Col span={12}>
                   <Input placeholder="CVC" />
                   </Col>
                   </Row>
                   </Row>  */}
            <img
              style={{ float: "right" }}
              height=""
              width=""
              src={require("../../assets/img/cards.png")}
            />
          </div>

          {/* <div style={{marginTop:'30px', paddingBottom:'0px'}} className='pay-box'>
                   <Row>
                   <Col span={24}>                   
                   <Input placeholder="Name for Order" />
                   </Col>
       

                   </Row> 
                   
                   </div> */}

          {/* <div className='btn-drawer btn-payment' style={{textAlign:'center',marginTop:'45px'}}>

                    <Button                                                   
                    className='round-white-btn'>
                    Back
                    </Button> 
                    <Link to='/orderconfirm'>
                    <Button 
                            
                    className='round-orange-btn'>
                    Confirm
                    </Button> 
                    </Link> 
                    </div> */}
        </div>
      </React.Fragment>
    );
  }
}

export default PaymentWindow;
